// Retina DPR resolution + canvas sizing — pure helpers, no imports (Node-loadable).
// NO import of config.js or 'phaser' here: config.js touches import.meta.env at load
// time and phaser touches window at load time, both of which break `node --test`;
// the world size is passed into canvasSize() by main.js instead.

const MAX_DPR = 2;

// Order: ?dpr=N (query) → localStorage.dpr → device ratio; result ∈ [1, max], snapped to
// the nearest integer (1 or 2 at the default max). A non-integer zoom disables Phaser's
// roundPixels and is an untested rendering mode, so we never land on e.g. 1.5.
export function resolveDpr({ search = '', storage = null, devicePixelRatio = 1, max = MAX_DPR } = {}) {
  const pick = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) && n >= 1 && n <= max ? n : null;
  };
  const readStorage = () => {
    try { return storage?.getItem?.('dpr'); } catch { return null; }
  };
  const fromQuery = pick(new URLSearchParams(search).get('dpr'));
  const fromStorage = pick(readStorage());
  const raw = fromQuery ?? fromStorage ?? (Number.isFinite(devicePixelRatio) ? devicePixelRatio : 1);
  const rounded = Math.round(raw);
  return Math.min(max, Math.max(1, rounded));
}

function safeStorage() {
  try { return window.localStorage; } catch { return null; }
}

export const DPR = typeof window === 'undefined'
  ? 1
  : resolveDpr({ search: window.location.search, storage: safeStorage(), devicePixelRatio: window.devicePixelRatio });

// Canvas size for a world of gameWidth x gameHeight (main.js passes GAME_WIDTH/HEIGHT).
export function canvasSize(gameWidth, gameHeight, dpr = DPR) {
  return { width: Math.round(gameWidth * dpr), height: Math.round(gameHeight * dpr) };
}
